<p-panel header="Online and Offline POS" [toggleable]="true">
  <div class="p-p-0">
    <div id="onlineoffline" class="" style="width: 100%; height: 470px"></div>
  </div>
</p-panel>
